import { AccountabilityExpense } from "~/application/types";
import { mapTravelerAdvanceDTO } from "./mapTravelerAdvanceDTO";
import { AccountabilityExpenseDTO, ApprovalModelDTO } from "../dtos";
import { toDate } from "~/utils/date.utils";
import { mapApprovalModelDTO } from "./mapApprovalModelDTO";
import { mapVoucherOcrDTO } from "./mapVoucherOcrDTO";
import { mapRouteDetailsDTO } from "./mapRouteDetailsDTO";
import { mapCardTransactionDTO } from "./mapCardTransactionDTO";

export function mapAccountabilityExpenseDTO(data: AccountabilityExpenseDTO): AccountabilityExpense {
  return {
    uuid: data.uuid,
    number: data.expense_number,
    order: data.order
      ? {
          number: data.order?.number,
          uuid: data.order?.uuid,
        }
      : undefined,
    expenseReport: data.expense_report && {
      id: data.expense_report.uuid,
      name: data.expense_report.name,
    },
    expenseType: {
      uuid: data.expense_type?.uuid,
      name: data.expense_type?.name,
    },
    deletedAt: data.deleted_at,
    expenseCategory: {
      uuid: data.expense_type?.expense_category?.uuid,
      name: data.expense_type?.expense_category?.name,
      icon: data.expense_type?.expense_category?.icon,
    },
    expenseDate: toDate(data.expense_date),
    violatedPolicies: data.violated_policies,
    voucherPath: data.voucher_path,
    suspectedVoucher: data.suspected_voucher && {
      expenseType: {
        name: data.suspected_voucher?.expense_type?.name,
        uuid: data.suspected_voucher?.expense_type?.uuid,
      },
      number: data.suspected_voucher?.expense_number,
      imageUrl: data.suspected_voucher?.image_url,
      establishment: data.suspected_voucher?.establishment,
      date: toDate(data.suspected_voucher?.date),
      expenseReport: data.suspected_voucher?.expense_report
        ? {
            uuid: data.suspected_voucher?.expense_report?.uuid,
            order: {
              uuid: data.suspected_voucher?.expense_report?.order?.uuid,
              number: data.suspected_voucher?.expense_report?.order?.order_number,
            },
          }
        : undefined,
      customerEmployee: data.suspected_voucher?.customer_employee
        ? {
            name: data.suspected_voucher?.customer_employee?.name,
            email: data.suspected_voucher?.customer_employee?.email,
            uuid: data.suspected_voucher?.customer_employee?.uuid,
          }
        : undefined,
      project: data.suspected_voucher?.project
        ? {
            uuid: data.suspected_voucher?.project?.uuid,
            name: data.suspected_voucher?.project?.name,
          }
        : undefined,
      phase: data.suspected_voucher?.phase
        ? {
            uuid: data.suspected_voucher?.phase?.uuid,
            name: data.suspected_voucher?.phase?.name,
          }
        : undefined,
      costCenter: data.suspected_voucher?.cost_center
        ? {
            uuid: data.suspected_voucher?.cost_center?.uuid,
            name: data.suspected_voucher?.cost_center?.name,
          }
        : undefined,
    },
    company: data.company,
    value: data.value,
    paymentMethod: data.payment_method,
    justification: data.justification,
    advanceOrder: data.advance_order ? mapTravelerAdvanceDTO(data.advance_order) : undefined,
    carModel: data.extra_info?.car_model,
    licensePlate: data.extra_info?.license_plate,
    isRefundable: data.refundable,
    kilometer: data.extra_info?.kilometer,
    odometerImageUrl: data.extra_info?.odometer_image_path,
    reasonRejected: data.reason_rejected
      ? {
          approver: data.reason_rejected.approver,
          reason: data.reason_rejected.reason,
          date: data.reason_rejected.date,
          justificationReasonReject: data.reason_rejected.employee_justification_reason_reject
            ? {
                customerEmployee:
                  data.reason_rejected.employee_justification_reason_reject.customer_employee,
                reason: data.reason_rejected.employee_justification_reason_reject.reason,
                date: toDate(data.reason_rejected.employee_justification_reason_reject.date),
              }
            : undefined,
        }
      : undefined,
    unsatisfiedPolicies:
      data.unsatisfied_policies?.map((policy) => ({
        uuid: data.uuid,
        policyParameter: policy.policy_parameter,
        typeValue: policy.type_value,
        value: policy.value,
        voucherRequired: policy.voucher_required,
      })) || [],
    status: data.status,
    costCenter: data.cost_center
      ? {
          uuid: data.cost_center?.uuid,
          name: data.cost_center?.name,
        }
      : undefined,
    project: data.project
      ? {
          uuid: data.project?.uuid,
          name: data.project?.name,
        }
      : undefined,
    phase: data.phase
      ? {
          uuid: data.phase?.uuid,
          name: data.phase?.name,
        }
      : undefined,
    customerEmployee: data.customer_employee
      ? {
          uuid: data.customer_employee?.uuid,
          name: data.customer_employee?.name,
        }
      : undefined,
    approvalModel: data.approval_model
      ? mapApprovalModelDTO(data.approval_model as ApprovalModelDTO)
      : undefined,
    customerReturn: data.customer_return,
    employeeReturn: data.employee_return,
    by: data.by,
    voucherOcr: data.voucher_ocr
      ? mapVoucherOcrDTO({ voucher_ocr: data.voucher_ocr, message: "" })
      : undefined,
    obs: data.obs,
    routeDetails: data.routes_details ? mapRouteDetailsDTO(data.routes_details) : undefined,
    approvedAmount: data.approved_amount ?? undefined,
    cardTransaction: data.card_transaction ? mapCardTransactionDTO(data.card_transaction) : null,
  };
}
